module.exports = __webpack_public_path__ + "img/rem3.cbae4278.jpg";